import { ILinksSpecDetail, Link, Links, LinksDTO, LinkSourceTarget, LinkSpecDetail } from "../models/links.models";
import { IRelatedItem } from "../models/related-items.models";

export const generateSpec = (linkType: Link, relation: ILinksSpecDetail<LinkSpecDetail>[]): Links<LinkSpecDetail> => {
  return {
    spec: {
      [linkType]: relation,
    },
  };
};

export const generateRelation = (id: string, type: LinkSpecDetail): ILinksSpecDetail<LinkSpecDetail>[] => {
  return [
    {
      id: id,
      type: type,
    },
  ];
};

export const generateLink = (sourceId: string, sourceTarget: LinkSourceTarget, relatedItem: IRelatedItem): LinksDTO<Link> => {
  return {
    sourceId: sourceId,
    sourceType: sourceTarget,
    targetId: relatedItem.id,
    targetType: relatedItem.iconType === "goal" ? "goals" : "metrics",
    linkType: relatedItem.linkType,
  };
};
